import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ContribuyentesService, FundersService } from '../../../services/service.index';
import { Router, ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';

declare function init_plugins();

@Component({
  selector: 'app-creacreditlinepesos',
  templateUrl: './creacreditlinepesos.component.html',
  styleUrls: ['./funders.component.css']
})
export class CreaCreditlinePesosComponent implements OnInit {
  @Input() idFunder: string;
  forma: FormGroup;
  idl: string;
  cadena: any[] = [];
  comanysector: any[] = [];
  lineaPesos: any [] = [];
  lineaDolares: any[] = [];
  nuevopesos = true;
  nuevodolares = true;
  validate_rebate = false;
  validate_fixed_rate = false;
  respvacio = {credit_available: '', credit_limit: '', rate: '', fixed_rate: '', has_rebate: '', rent_percentage:'', rebate_percentage:'' };
  rebateValue: any;
  rebateValued: any;
  rebatePercentageValue: any;
  rebatePercentageValued: any;
  rentPercentageValue: any;
  rentPercentageValued: any;
  fondeador = true;
  cadenasfondeadores: any[] = [];
  debtype: any[] = [];
  cols: any[];
  lineascredito: any[] = [];
  lineascreditod: any[] = [];
  ndd: boolean;
  
  constructor(
    private route: ActivatedRoute,
    public _contribuyentesService: ContribuyentesService,
    public _fundersService: FundersService,
    public router: Router
  ) { }


  ngOnInit() {
      Swal.showLoading();
      this.ndd = false;
      this.lineaPesos = [];
      this.lineaDolares = [];
      this.nuevopesos = true;
      this.nuevodolares = true;
      this.validate_rebate = false;
      this.validate_fixed_rate = false;
      this.fondeador = true;
      //this.idl = this.route.snapshot.paramMap.get('id');
      this.idl = this.idFunder;
      //FUNDING_CREDIT_LINE_TYPE
      this._contribuyentesService.getFundingCreditLineType().subscribe(resp => {
      if ( resp.value === 'FONDEADOR' ) {
      this.fondeador = true;
      this._fundersService.getCreditLinexFunder(this.idl).subscribe( resp => {
        this.lineaPesos = [];
        if (resp.length > 0) {
        for (const prop in resp) {
          if (resp[prop].company_id === null ) {
            if (resp[prop].currency === 'PESOS') {
              this.lineaPesos.push(resp[prop]);
              this.nuevopesos = false;
            }
          }
        }
      }
        if (this.lineaPesos.length === 0) {
          this.lineaPesos.push(this.respvacio);
      }
      } );
      } else if ( resp.value === 'CADENA' ) {
      this.fondeador = false;
      this._contribuyentesService.getCadenasParaFondeador().subscribe( resp => {this.cadenasfondeadores = resp;
      } )
      this._contribuyentesService.getDebType().subscribe(resp => {this.debtype = resp;})
      this._contribuyentesService.getCreditLines(this.idl).subscribe(resp => {
      this.lineascredito = resp.filter(row => row.currency === 'PESOS');
      this.lineascreditod = resp.filter(row => row.currency === 'DOLARES');
      for (const prop in this.lineascreditod) {
        if (this.lineascreditod[prop].company_id === null) {
          this.lineascreditod.splice(parseInt(prop),1);
        }
      }
      for (const prop in this.lineascredito) {
        if (this.lineascredito[prop].company_id === null) {
          this.lineascredito.splice(parseInt(prop),1);
        }
      }

      for (const prop in this.lineascredito) {
        this._contribuyentesService.getCompanyName(this.lineascredito[prop].company_id).subscribe( resp => {
          this.lineascredito[prop].nombrecadena = resp.data.attributes.business_name;
        } )
      }
      for (const prop in this.lineascreditod) {
        this._contribuyentesService.getCompanyName(this.lineascreditod[prop].company_id).subscribe( resp => {
          this.lineascreditod[prop].nombrecadena = resp.data.attributes.business_name;
        } )
      }
      })
      } else {
      this.fondeador = true;
      }
      }) 
      this.forma = new FormGroup({
        credit_limit: new FormControl( null , Validators.required ),
        credit_available: new FormControl( null , Validators.required ),
        rate: new FormControl( null , Validators.required ),
        fixed_rate: new FormControl( null , Validators.required ),
        has_rebate: new FormControl( null , Validators.required ),
        rebate: new FormControl( null , Validators.required ),
        rent_percentage: new FormControl( null , Validators.required ),
        rebate_percentage: new FormControl( null , Validators.required ),
        composite_tiie_type: new FormControl( null , Validators.required ),
        tiie_range: new FormControl( null , Validators.required ),
        credit_limitd: new FormControl( null , Validators.required ),
        credit_availabled: new FormControl( null , Validators.required ),
        rated: new FormControl( null , Validators.required ),
      } );
        Swal.close();
  }

  ngOnChanges(changes: SimpleChanges) {
  if (changes['idFunder']) {
    this.idl = changes['idFunder'].currentValue;
      this._contribuyentesService.getFundingCreditLineType().subscribe(resp => {
      if ( resp.value === 'FONDEADOR' ) {
      this.fondeador = true;
      this._fundersService.getCreditLinexFunder(this.idl).subscribe( resp => {
        this.lineaPesos = [];
        this.lineaDolares = [];
        if (resp.length > 0) {
        for (const prop in resp) {
          if (resp[prop].company_id === null ) {
            if (resp[prop].currency === 'PESOS') {
              this.lineaPesos.push(resp[prop]);
              this.nuevopesos = false;
            } else if (resp[prop].currency === 'DOLARES') {
              this.lineaDolares.push(resp[prop]);
              this.nuevodolares = false;
            }
          }
          
        }
      }
        if (this.lineaPesos.length === 0) {
          this.lineaPesos.push(this.respvacio);
      }
        if (this.lineaDolares.length === 0) {
        this.lineaDolares.push(this.respvacio);
    }
        Swal.close();
      } );
      } else if ( resp.value === 'CADENA' ) {
      this.fondeador = false;
      this._contribuyentesService.getCadenasParaFondeador().subscribe( resp => {this.cadenasfondeadores = resp
      } )
      this._contribuyentesService.getDebType().subscribe(resp => {this.debtype = resp;})
      this._contribuyentesService.getCreditLines(this.idl).subscribe(resp => {
      this.lineascredito = resp.filter(row => row.currency === 'PESOS');
      this.lineascreditod = resp.filter(row => row.currency === 'DOLARES');
      for (const prop in this.lineascreditod) {
        if (this.lineascreditod[prop].company_id === null) {
          this.lineascreditod.splice(parseInt(prop),1);
        }
      }
      for (const prop in this.lineascredito) {
        if (this.lineascredito[prop].company_id === null) {
          this.lineascredito.splice(parseInt(prop),1);
        }
      }

      for (const prop in this.lineascredito) {
        this._contribuyentesService.getCompanyName(this.lineascredito[prop].company_id).subscribe( resp => {
          this.lineascredito[prop].nombrecadena = resp.data.attributes.business_name;
        } )
      }
      for (const prop in this.lineascreditod) {
        this._contribuyentesService.getCompanyName(this.lineascreditod[prop].company_id).subscribe( resp => {
          this.lineascreditod[prop].nombrecadena = resp.data.attributes.business_name;
        } )
      }

      })
      } else {
      this.fondeador = true;
      }
      }) 
        Swal.close();
  }
}

  guardaPesos() {
    this.evalRebate();
    this.evalRentPercentage();
    const checkedInput = document.querySelector('input[name="tiie_typepe"]:checked') as HTMLInputElement | null; 
    const checkedInput2 = document.querySelector('input[name="tiie_rangepe"]:checked') as HTMLInputElement | null;
    const params = {
    funder_id: this.idl,
    currency: 'PESOS',
    credit_limit: (document.getElementById('credit_limit') as HTMLInputElement).value,
    credit_available: (document.getElementById('credit_available') as HTMLInputElement).value,
    rate: (document.getElementById('rate') as HTMLInputElement).value,
    rebate: this.rebateValue,
    rebate_percentage: this.rebatePercentageValue,
    rent_percentage: (document.getElementById('rent_percentage') as HTMLInputElement).value,
    fixed_rate: (document.querySelector('input[name = "fixed_rate"]:checked') as HTMLInputElement).value,
    has_rebate: (document.querySelector('input[name = "has_rebate"]:checked') as HTMLInputElement).value,

    composite_tiie_type: checkedInput ? checkedInput.value : null,
    tiie_range: checkedInput2 ? checkedInput2.value : null,
  };
    this._fundersService.creaCreditLinePesosDolares( this.idl, params).subscribe( () => {
        Swal.fire(
          'Creacion de Linea de credito',
          'Exitosa',
          'success'
       ).then( () => this.ngOnInit() ) }, (err) => {         console.log(err);
                                                      Swal.fire(
                              'Error al crear La linea de credito',
                              'Error',
                              'error'
                           );
                        } );
  }

  //MODIFICA LA INFO CON PARAMETRO CADENA
  modificapesos(item) {
    //this.evalRebate(); rebatePercentageValue = 0;
    //this.evalRentPercentage(); rebatePercentageValue = 0;
    if (item.has_rebate === false || item.rebate_percentage === '' || item.rebate_percentage === null) {
        item.rebate_percentage = 0;
    }
    if (item.fixed_rate === true) {
      item.tiie_range = null;
      item.composite_tiie_type = null;
    }
    //const checkedInput = document.querySelector('input[name="tiie_typepe"]:checked') as HTMLInputElement | null; 
    //const checkedInput2 = document.querySelector('input[name="tiie_rangepe"]:checked') as HTMLInputElement | null;
    const params = {
      currency: 'PESOS',
      credit_limit: item.credit_limit,
      credit_available: item.credit_available,
      rate: item.rate,
      rebate: item.rebate,
      rebate_percentage: item.rebate_percentage,
      rent_percentage: item.rent_percentage,
      fixed_rate: item.fixed_rate,
      has_rebate: item.has_rebate,
      composite_tiie_type: item.composite_tiie_type,
      tiie_range: item.tiie_range,
      company_id: item.company_id,
      debt_type: item.debt_type,
    };
    this._fundersService.modificaCreditLinePesosDolares( this.idl, item.id, params).subscribe( () => {
        Swal.fire(
          'Modificacion de Linea de credito',
          'Exitosa',
          'success'
       ).then( () => this.ngOnInit() ) }, (err) => {         console.log(err);
                                Swal.fire(
                                  'Error al modificar La linea de credito',
                                  'Error',
                                  'error'
                               );
                            } );
  }

  borrapesos(idll) {
    Swal.fire({
      title: 'Desea eliminar la linea de credito?',
        text: '',
        icon: 'question',
        showConfirmButton: true,
        showCancelButton: true,
        allowOutsideClick: false
    }). then ( res => {
      if ( res.value ) {
        this._fundersService.borraCeditLinePesosDolares(this.idl, idll).subscribe( resp => { Swal.fire({
            title: 'La linea de credito se elimino',
            text: 'Con exito',
            icon: 'success',
            showConfirmButton: true,
            showCancelButton: false,
            allowOutsideClick: false
          }). then ( res2 => {
            if ( res2.value ) {
              this.ngOnInit();
            }
          } ); }, (err) => {
            console.log(err);
            Swal.fire({
              title: 'Ocurrio un error',
              text: err.error.errors[0],
              icon: 'error',
              showConfirmButton: true,
              showCancelButton: false,
              allowOutsideClick: false
            }). then ( res1 => {
              if ( res1.value ) {
                this.ngOnInit();
              }
            } );
           } );
      }
    });
  }

  //GUARDA LA INFO DE UNO NUEVO CON PARAMETRO CADENA
  guardaPesosCadenas() {
    this.evalRebate();
    this.evalRentPercentage();
    const checkedInput = document.querySelector('input[name="tiie_typepe"]:checked') as HTMLInputElement | null; 
    const checkedInput2 = document.querySelector('input[name="tiie_rangepe"]:checked') as HTMLInputElement | null;
    const params = {
      funder_id: this.idl,
      currency: 'PESOS',
      credit_limit: (document.getElementById('credit_limit_c') as HTMLInputElement).value,
      credit_available: (document.getElementById('credit_available_c') as HTMLInputElement).value,
      rate: (document.getElementById('rate_c') as HTMLInputElement).value,
      rebate: this.rebateValue,
      rebate_percentage: this.rebatePercentageValue,
      rent_percentage: (document.getElementById('rent_percentage') as HTMLInputElement).value,
      fixed_rate: (document.querySelector('input[name = "fixed_rate"]:checked') as HTMLInputElement).value,
      has_rebate: (document.querySelector('input[name = "has_rebate"]:checked') as HTMLInputElement).value,
      composite_tiie_type: checkedInput ? checkedInput.value : null,
      tiie_range: checkedInput2 ? checkedInput2.value : null,
      company_id: (document.getElementById('cadena_c') as HTMLInputElement).value,
      debt_type: (document.getElementById('debtype_c') as HTMLInputElement).value,
    };
      this._fundersService.creaCreditLinePesosDolares( this.idl, params).subscribe( () => {
      Swal.fire({
            title: 'Creacion de linea de credito exitosa',
            text: '',
            icon: 'success',
            showConfirmButton: true,
            showCancelButton: false,
            allowOutsideClick: false
          }). then ( res2 => {
            if ( res2.value ) {
              this.ngOnInit();
            }
          } )
    },(err) => { console.log(err);
                                                        Swal.fire(
                                'Error al crear La linea de credito',
                                'Error',
                                'error'
                             );
                          } );
  }

  evalRebate(){
    if((document.getElementById('rebate_percentage') as HTMLInputElement)){
      this.rebatePercentageValue = (document.getElementById('rebate_percentage') as HTMLInputElement).value
    }else{
      this.rebatePercentageValue = 0;
    }
  }

  evalRentPercentage(){
    if((document.getElementById('rent_percentage') as HTMLInputElement)){
      this.rentPercentageValue = (document.getElementById('rent_percentage') as HTMLInputElement).value
    }else{
      this.rentPercentageValue = 0;
    }
  }

  evalRebated(){
    if((document.getElementById('rebate_percentaged') as HTMLInputElement)){
      this.rebatePercentageValued = (document.getElementById('rebate_percentaged') as HTMLInputElement).value
    }else{
      this.rebatePercentageValued = 0;
    }
  }

  evalRentPercentaged(){
    if((document.getElementById('rent_percentaged') as HTMLInputElement)){
      this.rentPercentageValued = (document.getElementById('rent_percentaged') as HTMLInputElement).value
    }else{
      this.rentPercentageValued = 0;
    }
  }

  clickcheckbox(value){
    if ( value == 'true' ) {
      this.validate_rebate = true
    } else {
      this.validate_rebate = false
    }
  }

  clickcheckboxfixedrate(value){
    if ( value == 'true' ) {
      this.validate_fixed_rate = true
    } else {
      this.validate_fixed_rate = false
    }
  }

  borraLineaCreditoPesosCadenas ( idl ) {
    Swal.fire({
      title: 'Desea eliminar la linea de credito?',
        text: '',
        icon: 'question',
        showConfirmButton: true,
        showCancelButton: true,
        allowOutsideClick: false
    }). then ( res => {
      if ( res.value ) {
        this._fundersService.borraCeditLinePesosDolares(this.idl, idl).subscribe( resp => { Swal.fire({
            title: 'La linea de credito se elimino',
            text: 'Con exito',
            icon: 'success',
            showConfirmButton: true,
            showCancelButton: false,
            allowOutsideClick: false
          }). then ( res2 => {
            if ( res2.value ) {
              this.ngOnInit();
            }
          } ); }, (err) => {
            console.log(err);
            Swal.fire({
              title: 'Ocurrio un error',
              text: err.error.errors[0],
              icon: 'error',
              showConfirmButton: true,
              showCancelButton: false,
              allowOutsideClick: false
            }). then ( res1 => {
              if ( res1.value ) {
                this.ngOnInit();
              }
            } );
           } );
      }
    });
  }

  nd() {
  this.ndd = !this.ndd;
}
}
